// Customizable Area Start
import React from "react";
import EditPreferenceController, {
  MapPreferencesData,
  Props,
  configJSON,
} from "./EditPreferenceController";
import {
  styled,
  Dialog,
  Box,
  Typography,
  DialogActions,
  Select,
  MenuItem,
  OutlinedInput,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import {
  TableRow,
  TableCell,
  OrderTable,
  RowContainer,
} from "../../../components/src/OrderTable/src";
import {
  renderBaseOnConditions,
  sortCondition,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { colors } from "../../../blocks/utilities/src/Colors";
import { MainButtonComponent } from "../../../components/src/customComponents/CustomTags.web";
import { MenuProps } from "../../../blocks/email-account-registration/src/CreateProfessionController.web";
import {
  RadioCheckedIcon,
  RadioUnCheckedIcon,
  checkedIcon,
  unCheckedIcon,
} from "./assets";
import { CustomMenuUpchargeDrop } from "../../../blocks/cfplantdashboard2/src/utils";
import { CustomSearchableMultiSelect } from "../../../components/src/customComponent/CustomSearchableMultiSelect.web";
import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";
// Customizable Area End
import '../assets/style.css'
// Customizable Area Start
const String = configJSON.NewStrings;
// Customizable Area End

export default class EditPreference extends EditPreferenceController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  renderPreferenceBody(preferenceData: MapPreferencesData) {
    const preferences_list = preferenceData.preferece_list;
    return (
      <SelectUpchargeRow>
        <div className='wrapper-componenet'>
         <AutocompleteSelect 
      data-test-id="preferenceDropdown"
      fieldName="preference"
      placeholder="Select Preference"
      listBoxStyle={{ maxHeight: 270 }}
      options={preferences_list.map((pref) => ({
        id: pref.id.toString(),     
        option: pref.name  
      }))}
      value={this.getSelectedPreferenceId(preferenceData.order_items_preference_id)}
      onChange={(
        _blank: React.ChangeEvent<HTMLInputElement>,
        selectedValue: { id: string; option: string } | null
      ) => {
        /* istanbul ignore next */
        if (selectedValue) {
          this.handlePreferenceSelect(
            Number(selectedValue.id),
            preferenceData.order_items_preference_id
          );
        }
      }}
    />
        </div>
      </SelectUpchargeRow>
    );
  }

  renderUpchargeBody(preferenceData: MapPreferencesData, index: number) {
    const { selectedPreferencesData } = this.state;
    const upcharges_list = preferenceData.upcharge_list;
  
    const currentPreference = selectedPreferencesData.find(
      (item) => item.order_items_preference_id === preferenceData.order_items_preference_id
    );
  
    const selectedIds = currentPreference?.selected_upcharges || [];
  
    return (
      <SelectUpchargeRow key={preferenceData.order_items_preference_id}>
        <div>
          <div className="wrapper-componenet"></div>
  
          {upcharges_list.length > 0 && (
            <Box className="bottom-upcharge-select-wrap">
             <CustomSelect
                multiple
                displayEmpty
                input={<OutlinedInput />}
                disableUnderline
                name="upchargeSelect"
                data-test-id="field-upchargeSelect"
                value={selectedIds}
                onChange={(event: React.ChangeEvent<{ value: unknown }>) =>
                  this.handleSelectionUpchargeFromDropdown(
                    event.target.value as number[],
                    preferenceData.order_items_preference_id
                  )
                }
                renderValue={(selected: any) => {
              const selectedUpcharges = upcharges_list.filter((item) =>
                                  selected.includes(item.id)
                                );

                  if (selectedUpcharges.length === 0) return 'See all upcharges';

                  const firstName = selectedUpcharges[0].name.trim();
                  const suffix = selectedUpcharges.length > 1 ? '...' : '';

                  return `${firstName}${suffix}`;
                }}
                MenuProps={CustomMenuUpchargeDrop}
              >
                <MenuItem
                  disableRipple
                  disableTouchRipple
                  onClick={(event) => event.stopPropagation()}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search Upcharge"
                    value={this.state.upchargeSearch}
                    onChange={(event) =>
                      this.setState({
                        upchargeSearch: event.target.value
                      })
                    }
                    onClick={(event) => event.stopPropagation()}
                    onKeyDown={(event) => event.stopPropagation()}
                  />
                </MenuItem>
                {this.getFilteredUpcharges(upcharges_list).map((dropUpcharge) => (
                  <UpchargeSelectMenuItem
                    key={dropUpcharge.id}
                    value={dropUpcharge.id}
                  >
                    <div className="upcharge-main-item">
                      <img
                        data-test-id="checkbox-selectAll"
                        className="cursor-pointer"
                        src={
                          sortCondition(
                            selectedIds.includes(dropUpcharge.id),
                            checkedIcon,
                            unCheckedIcon
                          ) as string
                        }
                        alt="checkbox"
                      />
                      <div className="upcharge-content">
                        <img
                          src={dropUpcharge.icon}
                          className="upchargeIcon"
                          alt="icon"
                        />
                        <div className="upcharge-content-box">
                          <span
                          //@ts-ignore
                            className={sortCondition(
                              selectedIds.includes(dropUpcharge.id),
                              'dropdownUpchargeActiveName',
                              'dropdownUpchargeName'
                            )}
                          >
                            {dropUpcharge.name}
                          </span>

                          <span
                            //@ts-ignore
                            className={sortCondition(
                              selectedIds.includes(dropUpcharge.id),
                              'dropdownUpchargeActiveName',
                              'dropdownUpchargeName'
                            )}
                          >
                            SAR {Number(dropUpcharge.price).toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </UpchargeSelectMenuItem>
                ))}
              </CustomSelect>
            </Box>
          )}
        </div>
      </SelectUpchargeRow>
    );
  }

  renderSpecificationBody(preferenceData: MapPreferencesData, specificationName: string) {
    if (!preferenceData?.specifications?.length) return null;
  
    const foundSpecification = preferenceData.specifications.find(
      (spec) => spec.name.toLowerCase() === specificationName.toLowerCase()
    );
  
    if (!foundSpecification) return <div>No {specificationName} found</div>;
  
    return (
      <SelectUpchargeRow>
        <SpecificationSelectContainer key={foundSpecification.id}>
          <CustomSearchableMultiSelect
          className="dropdownBox specification-dropdown"
          dropdownStyle={{ width: '300px',maxWidth:"300px" }}
            keepSelectAll={false}
            id={"specification"}
            name={"specification"}
            dataTestId={`field-specifications-${preferenceData.order_items_preference_id}-${foundSpecification.id}`}
            checkSelectAllText={() => {}}
            value={this.handleSelectedSpecificationVal(
              foundSpecification.name,
              preferenceData.order_items_preference_id
            )}
            optionList={this.getSpecificationOptionList(
              foundSpecification.options_attributes
            )}
            placeHolderText={`Select ${foundSpecification.name}`}
            changeInputOnClear
            handleScroll={() => {}}
            handleClickOnSelectAll={() => {}}
            debouncedFunction={(getValue: string) => {
              if (getValue === '') {
                this.handleClearMultiSelect(
                  foundSpecification.name,
                  preferenceData.order_items_preference_id
                )
              }
            }}
            handleSelectOptions={(
              value: { id: number; option: string }[],
              option: { id: number; option: string }
            ) => {
              this.handleOnSelectSpecification(
                preferenceData.order_items_preference_id,
                foundSpecification.id,
                value,
                option
              );
            }}
            emptyDataMessage={"No data found"}
            handleEmptyAutoSelectValue={() => {}}
            selectedOptionForList={this.handleSelectedSpecificationVal(
              foundSpecification.name,
              preferenceData.order_items_preference_id
            )}
            //@ts-ignore
            renderTags={(selectedItems) => (
              <span className="selected-items">
                {selectedItems.slice(0, 1).map((item: any) => item.option).join(', ')}
                {selectedItems.length > 1 ? '...' : ''}
              </span>
            )}
          />
        </SpecificationSelectContainer>
      </SelectUpchargeRow>
    );
  }

  showSQMData(height: string, width: string, weight: string) {
    return (
      <>
        {Number(height) !== 0 && Number(width) !== 0 && (
          <>
            <Typography className='sqm-size'>{height} m</Typography>
            <span className='cross-span'>X</span>
            <Typography className='sqm-size'>{width} m</Typography>
          </>
        )}
        {Number(weight) !== 0 && (
          <Typography className='sqm-size'>{weight} Kg</Typography>
        )}
      </>
    );
  }

  renderAdjustOrderCustomer() {
    const { laundryOrder } = this.props;
    const customer = laundryOrder?.customer;
    const store = laundryOrder?.store_management.data.attributes;

    return (
      <OrderDetailsHeaderContainer className='responsive'>
        <OrderDetailsHeadingText>
          <div>
            <b>{String.adjustmentPopup_customer_name}</b>
            {customer?.full_name}
          </div>
          <div>
            <b>{String.adjustmentPopup_customer_mobile_no}</b>
            {customer?.full_phone_number}
          </div>

          <div>
            <b>{String.adjustmentPopup_business}</b>{" "}
            {customer?.business || "--"}
          </div>

          <div>
            <b>{String.adjustmentPopup_order_creation_date}</b>
            {this.getMomentFormat(laundryOrder?.created_at || "")}
          </div>
        </OrderDetailsHeadingText>
        <OrderDetailsHeadingText>
          <div>
            <b>{String.adjustmentPopup_order_id}</b>{" "}
            {laundryOrder?.order_number}
          </div>
          <div>
            <b>{String.adjustmentPopup_store_name}</b> {store?.store_name}
          </div>

          <div>
            <b>{String.adjustmentPopup_price_list}</b>{" "}
            {laundryOrder?.price_list_name || "--"}
          </div>

          <div>
            <b>{String.adjustmentPopup_discount}</b> {laundryOrder?.currency}{" "}
            {laundryOrder?.applied_discount || "--"}
          </div>

          <div>
            <b>{String.adjustmentPopup_promocode_applied}</b>
            {laundryOrder?.promo_code?.promo_code || "--"}
          </div>
        </OrderDetailsHeadingText>
      </OrderDetailsHeaderContainer>
    );
  }

  renderCommonUpchargePart() {
    const {
      commonUpchargeList,
      commonPreferencesList,
      selectedCommonPreference,
      selectedCommonUpcharges,
    } = this.state;
    return (
      <Box className='top-dropdown-wrap'>
        <Box className='max-250'>
          <div className='label'>Common Upcharge</div>
        <Select
            fullWidth
            multiple
            value={[]}
            renderValue={() => "Select Upcharges"}
            variant='outlined'
            displayEmpty
            data-test-id={"select-common-upcharge"}
            name={"common-upcharge"}
            input={<OutlinedInput />}
            MenuProps={MenuProps}
            onChange={(
              event: React.ChangeEvent<{
                value: unknown;
              }>
            ) =>
              this.handleChangeCommonUpcharge(event.target.value as unknown[])
            }
          >
            <MenuItem
              disableRipple
              disableTouchRipple
              onClick={(event) => event.stopPropagation()}
            >
              <TextField
                fullWidth
                autoFocus
                variant="outlined"
                placeholder="Search Upcharge"
                value={this.state.commonUpchargeSearch}
                onChange={(event: { target: { value: any; }; }) =>
                  this.setState({
                    commonUpchargeSearch: event.target.value
                  })
                }
                onClick={(event: { stopPropagation: () => any; }) => event.stopPropagation()}
                onKeyDown={(event: { stopPropagation: () => any; }) => event.stopPropagation()}
              />
            </MenuItem>

            {renderBaseOnConditions(
              commonUpchargeList.length > 0,
              <UpchargeSelectMenuItem value={"selectAll"}>
                <Box className='d-flex'>
                  <img
                    data-test-id='checkbox-selectAll'
                    className='cursor-pointer'
                    src={
                      sortCondition(
                        selectedCommonUpcharges?.length ==
                          commonUpchargeList.length,
                        checkedIcon,
                        unCheckedIcon
                      ) as string
                    }
                  />
                  <span className='upcharge-name ml-8'>Select All</span>
                </Box>
              </UpchargeSelectMenuItem>,
              <></>
            )}

            {this.getFilteredCommonUpcharges().map((commonUpcharge) => {
              return (
                <UpchargeSelectMenuItem
                  key={commonUpcharge.id}
                  value={commonUpcharge.id}
                >
                  <Box className='d-flex'>
                    <img
                      data-test-id='checkbox-selectAll'
                      className='cursor-pointer'
                      src={
                        sortCondition(
                          commonUpcharge.checked,
                          checkedIcon,
                          unCheckedIcon
                        ) as string
                      }
                    />
                    <span className='upcharge-name ml-8'>
                      {commonUpcharge.name}
                    </span>
                  </Box>
                </UpchargeSelectMenuItem>
              );
            })}

            {commonUpchargeList.length === 0 && (
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontFamily: "Montserrat",
                  margin: "0 0 0 8px"
                }}
              >
                No Upcharge
              </span>
            )}

            {commonUpchargeList.length > 0 &&
              this.getFilteredCommonUpcharges().length === 0 && (
                <MenuItem disabled>
                  No matching upcharge
                </MenuItem>
              )}
          </Select>
        </Box>
        <Box className='max-250'>
          <div className='label'>Common Preference</div>
          <Select
            fullWidth
            value={selectedCommonPreference}
            renderValue={
              selectedCommonPreference ? undefined : () => "Select Preferences"
            }
            variant='outlined'
            displayEmpty
            input={<OutlinedInput />}
            data-test-id={"select-common-preference"}
            name={"select-preference"}
            MenuProps={MenuProps}
            onChange={(
              event: React.ChangeEvent<{
                value: unknown;
              }>
            ) =>
              this.handleChangeCommonPreference(event.target.value as number)
            }
          >
            {commonPreferencesList.map((preference) => {
              return (
                <MenuItem key={preference.id} value={preference.id}>
                  {preference.name}
                </MenuItem>
              );
            })}
          </Select>
        </Box>
      </Box>
    );
  }

  // Customizable Area End

  render() {
    // Customizable Area Start
    const { open, handleClosePopup, isCfPlantAdjustmentscreen } = this.props;
    const { preferencesMapData, isEditPreferenceLoading } = this.state;
    // Customizable Area End
    return (
      // Customizable Area Start
      <StyledDialogWrapper open={open} fullWidth maxWidth='xl'>
        <h3 className='dialog-title'>
          {isCfPlantAdjustmentscreen
            ? String.selectUpchargetxt
            : String.editPreferencetxt}
        </h3>
        {!isCfPlantAdjustmentscreen && this.renderCommonUpchargePart()}
        {isCfPlantAdjustmentscreen && <Box className='p-10' />}
        {isCfPlantAdjustmentscreen && this.renderAdjustOrderCustomer()}
        <Box className='p-10' />
        <OrderTable>
          <RowContainer header>
            <TableRow columns={"repeat(auto-fit, minmax(150px, 1fr))"}>
            <TableCell
                      key={String.txtItemNameService}
                      header
                      content={String.txtItemNameService}
                      className='align-item-center'
                    />
               <TableCell
                      key={String.txtPreference}
                      header
                      content={String.txtPreference}
                      className='align-item-center'
                    />
              {this.state.specificationData?.slice() 
  .sort((a: any, b: any) => a.id - b.id).map(
                (heading: any) => {
                  return (
                    <TableCell
                      key={heading.id}
                      header
                      content={heading.name}
                      className='align-item-center'
                    />
                  );
                }
              )}
              <TableCell
                      key={"Upcharges"}
                      header
                      content={"Upcharges"}
                      className='align-item-center'
                    />
            </TableRow>
          </RowContainer>
          {isEditPreferenceLoading ? (
              <Box className='loader'>
                <CircularProgress />
              </Box>
            ) :<>
          {preferencesMapData.map((preference, index) => (
  <RowContainer key={index}>
    <TableRow columns={"repeat(auto-fit, minmax(150px, 1fr))"}>
      <TableCell style={{display:"flex", alignItems:"center"}} content={<Box className='d-flex' style={{display:"flex"}}>
                          <Typography className='product-name'>
                            {preference.product_name} |&nbsp;
                          </Typography>
                          <Box className='d-flex'>
                            <img
                              src={preference.service_icon}
                              width={20}
                              height={20}
                            />
                            {/* <Typography className='product-name'>
                              {preference.service_name}
                            </Typography> */}
                          </Box>
                        </Box>} />
      <TableCell content={this.renderPreferenceBody(preference)} />
      {this.state.specificationData
  .slice() 
  .sort((a: any, b: any) => a.id - b.id) 
  .map((spec: any) => {
    const matchedSpec = preference.specifications.find(
      (s: any) => s.name.toLowerCase() === spec.name.toLowerCase()
    );
    return (
      <TableCell
        key={spec.id}
        style={{ display: "flex", alignItems: "center", width: "100%" }}
        content={
          matchedSpec
            ? this.renderSpecificationBody(preference, spec.name)
            : <div style={{ fontSize: "12px" }}>No {spec.name} found</div>
        }
      />
    );
  })}
      <TableCell
       style={{display:"flex", width:"100%"}}
  content={
    preference.upcharge_list && preference.upcharge_list.length > 0
      ? this.renderUpchargeBody(preference, index)
      : <div style={{fontSize:"12px",display:"flex", alignItems:"center", width:"100%", height:"100%"}}>No Upcharge found</div>
  }
/>
    </TableRow>
  </RowContainer>
))}</>}
          {/* <RowContainer>
            {isEditPreferenceLoading ? (
              <Box className='loader'>
                <CircularProgress />
              </Box>
            ) : (
              preferencesMapData.map((preference) => {
                return (
                  <TableRow columns={"2fr 8fr"} key={preference.product_name}>
                    {[
                      <PreferenceTopName>
                        <Box className='d-flex'>
                          <Typography className='product-name'>
                            {preference.product_name} |
                          </Typography>
                          <Box className='d-flex'>
                            <img
                              src={preference.service_icon}
                              width={20}
                              height={20}
                            />
                            <Typography className='product-name'>
                              {preference.service_name}
                            </Typography>
                          </Box>
                        </Box>
                        <Box className='d-flex'>
                          {this.showSQMData(
                            preference.height,
                            preference.width,
                            preference.weight
                          )}
                        </Box>
                      </PreferenceTopName>,
                      <SpecsContainer>
                        {this.renderSpecificationBody(preference,"Color")}
                        {this.renderPreferenceBody(preference)}
                        {this.renderUpchargeBody(preference)}
                      </SpecsContainer>,
                    ].map((heading: unknown, index: number) => {
                      return (
                        <TableCell
                          content={heading as React.ReactNode}
                          type={
                            sortCondition(index == 0, "left", "right") as
                              | "middle"
                              | "left"
                              | "right"
                              | "none"
                              | undefined
                          }
                        />
                      );
                    })}
                  </TableRow>
                );
              })
            )}
          </RowContainer> */}
        </OrderTable>
        <DialogActions className='dialogActionWrapper'>
          <MainButtonComponent
            data-test-id='btnSubCancel'
            className='buttonSecondary'
            onClick={() => handleClosePopup()}
          >
            {String.cancel}
          </MainButtonComponent>
          <MainButtonComponent
            data-test-id='btnSubNext'
            onClick={() => this.onSavePreferences()}
          >
            {String.save}
          </MainButtonComponent>
        </DialogActions>
      </StyledDialogWrapper>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const StyledDialogWrapper = styled(Dialog)({
  "& .loader": {
    height: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .MuiDialog-paper": {
    borderRadius: 20,
    padding: "24px 16px 0 16px",
  },
  "& .dialog-title": {
    fontSize: 24,
    fontWeight: 600,
    paddingBottom: 16,
    textAlign: "center",
    fontFamily: "Montserrat",
  },
  "& .p-10": {
    padding: 10,
  },
  "& .max-250": {
    maxWidth: 250,
    width: "100%",
  },
  "& .top-dropdown-wrap": {
    width: "100%",
    display: "flex",
    justifyContent: "end",
    gap: "12px",
  },
  "& .dialogActionWrapper": {
    justifyContent: "center",
    paddingTop: "24px",
    paddingBottom: "32px",
  },
  "& .label": {
    fontSize: 14,
    fontWeight: 500,
    margin: "0 0 6px 0",
    color: colors().darkliver,
  },
  "& .upcharge-name": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    fontFamily: "Montserrat",
    margin: "0 0 0 8px",
  },
});

const PreferenceTopName = styled("div")({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "5px",
  "& .product-name": {
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
  },
  "& .sqm-size": {
    fontSize: "13px",
    fontWeight: 400,
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
  },
  "& .cross-span": {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
    margin: "0 6px",
  },
  "& .d-flex": {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
});

const SpecsContainer = styled("div")({
  gap: 24,
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const SelectUpchargeRow = styled("div")({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "150px 1fr",
  "& p:first-child": {
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    whiteSpace: "pre",
  },
  "& .MuiInputBase-root":{
 padding:"6px"
  },
  "& .specification-wrapper-componenet": {
    width: "100%",
    flex: "1 1 0",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "14px",
  },
  "& .wrapper-componenet": {
    width: "100%",
    flex: "1 1 0",
    display: "block",
    gridTemplateColumns: "1fr 1fr",
    gap: "14px",
  },
  "& .preference-main-wrap": {
    display: "flex",
    gap: "14px",
    alignItems: "center",
  },
  "& .preference-main": {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  "& .preference-name": {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Montserrat",
  },
  "& .shadow-box": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 8,
    borderRadius: "8px",
    border: `1px solid ${colors().lightborder}`,
  },
  "& .active-preference": {
    background: colors().brightgray,
  },
  "& .preference-icon": {
    height: 20,
    width: 20,
  },
  "& .upcharge-icon": {
    height: 24,
    width: 24,
  },
  "& .bottom-upcharge-select-wrap": {
    padding: "0",
  },
  "@media only screen and (max-width: 1024px)": {
    "& .specification-wrapper-componenet": {
      gridTemplateColumns: "1fr 1fr",
    },
  }
});

const SpecificationSelectContainer = styled("div")({
  "& .fixed-height-select": {
    overflow: "hidden",
    display: "flex",
    height: "48px",
    alignItems: "center",
    position:"relative"
  },
  "& .selected-items + input": {
    width: "0",
    height: "0",
    padding: "0",
    margin: "0",
    border: "none",
    opacity: 0,
    pointerEvents: "none" // prevents keyboard focus but allows dropdown logic to work
  },
  "& .selected-items":{
    position:"absolute",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "inline-block",
  width: "100px",
  },
  "& .label": {
    fontSize: 14,
    fontWeight: 500,
    margin: "0 0 6px 0",
    color: colors().darkliver,
  },
  "& .MuiAutocomplete-root":{
minWidth:"100%"
  },
  "& .MuiInputBase-root":{
minHeight:"48px",
padding: "5.5px 4px"
  },
  "& .MuiSelect-root": {
    padding: 14,
    paddingTop: 16,
  },
});

const UpchargeSelectMenuItem = styled(MenuItem)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: "8px",
  paddingBottom: "8px",
  whiteSpace: "normal",
  "&.MuiListItem-root.Mui-selected": {
    backgroundColor: `${colors().brightgray} !important`,
  },
  "& .upcharge-content": {
    display: "flex",
    alignItems: "flex-start",
  },
  "& .upcharge-content-box": {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    flexWrap: "wrap",
  },
  "& .upcharge-main-item": {
    display: "flex",
    alignItems: "flex-start",
  },
  "& .upchargeName": {
    fontSize: "15px",
    fontFamily: "Montserrat",
  },
  "& .upchargeActiveName": {
    fontSize: "15px",
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
  },
  "& .dropdownUpchargeName": {
    fontSize: "14px",
    fontFamily: "Montserrat",
  },
  "& .dropdownUpchargeActiveName": {
    fontSize: "14px",
    fontFamily: "Montserrat",
    color: colors().cyancobaltblue,
  },
  "& .upchargeIcon": {
    minWidth: "18px",
    maxWidth: "18px",
    minHeight: "18px",
    maxHeight: "18px",
    borderRadius: "4px",
    margin: "0 8px",
  },
  "& .d-flex": {
    display: "flex",
    alignItems: "center",
  },
  "& .upcharge-name": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    fontFamily: "Montserrat",
    margin: "0 0 0 8px",
  },
  "& .ml-8": {
    margin: "0 0 0 8px",
  },
});

const CustomSelect = styled(Select)({
  padding: "10px 8px",
  borderRadius: "8px",
  border: `1px solid ${colors().lightborder}`,
  fontSize: "12px",
  fontWeight: 400,
  background: colors().white,
  fontFamily: "Montserrat",

  width: "200px",
  minWidth: "200px",
  height: "49px",

  "& .MuiSelect-select": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  "&:focus": {
    borderRadius: "8px",
    borderColor: colors().cyancobaltblue,
    outline: "none",
  },
});
export const OrderDetailsHeaderContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  padding: 16,
  borderRadius: 12,
  border: "1px solid #DEDEDE",
  "& > div:first-child": {
    paddingBottom: 8,
  },
});

const OrderDetailsHeadingText = styled("div")({
  fontSize: 16,
  fontWeight: 500,
  color: "#1A1A1A",
  alignItems: "flex-start",
  flexDirection: "column",
  fontFamily: "Montserrat",
  justifyContent: "space-between",
  "& div": {
    margin: "0 0 6px 0",
  },
  "& div:last-child": {
    margin: "0",
  },
});

// Customizable Area End
